import { IBrandResource } from "./IBrandResource";

export enum BrandStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export enum BrandContentVisibility {
    PRIVATE = "private",
    PROTECTED = "protected",
}

export interface IBrand extends IBrandResource {
    domainUi: string;
    nbUsersMax: number;
    expiredAt: string;
    status: BrandStatus;
    contentProtectedViewable: boolean;
    /** Framework IRI references array */
    frameworks?: string[];
    contentVisibility: BrandContentVisibility;
}
